import { BigNumber } from '../utils/bignumber';
import moment from 'moment';

import { NULL_ADDRESS, NULL_BYTES32, NULL_ECDSA_SIGNATURE } from '../utils/constants'

import { ECDSASignature } from './ecdsa_signature'

export const QUOTE_ORDER_DATA_DEFAULTS = {
  id: new BigNumber(0),
  applicationHash: NULL_BYTES32,
  premium: new BigNumber(0),
  coverageLimit: new BigNumber(0),
  type: 'Term Life',
  duration: new BigNumber(
    moment()
      .add(20, 'years')
      .unix()
  ),
  carrier: NULL_ADDRESS,
  expiration: new BigNumber(
    moment()
      .add(30, 'days')
      .unix()
  ),
  isActive: true,
  carrierSignature: NULL_ECDSA_SIGNATURE
}

export interface QuoteOrderData {
  id?: BigNumber;
  applicationHash?: string;
  premium?: BigNumber;
  coverageLimit?: BigNumber;
  type?: string;
  duration: BigNumber;
  carrier?: string;
  expiration?: BigNumber;
  isActive?: boolean;
  carrierSignature?: ECDSASignature;
}